import React from 'react';
import {
  Box, FormControlLabel, FormGroup, Switch, Typography,
} from '@mui/material';
import { HSpinner } from 'BaseComponents';


const QuestionBillableSwitch = ({
  isLoading,
  isQuestionBillable,
  setIsQuestionBillable,
}) => {
  if (isLoading) {
    return (
      <Box display='flex' alignItems='center' gap={2}>
        <HSpinner />
        <Typography variant='body2'>Loading billable configuration...</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant='subtitle1' mb={1}>
        Question Billable Configuration
      </Typography>
      <Typography variant='body2' mb={2} color='text.secondary'>
        Mark this question as billable for cost tracking and reporting purposes.
      </Typography>
      <FormGroup>
        <FormControlLabel
          control={(
            <Switch
              checked={isQuestionBillable}
              onChange={(e) => setIsQuestionBillable(e.target.checked)}
              color='secondary'
            />
          )}
          label={(
            <Typography variant='body2'>
              Billable
            </Typography>
          )}
        />
      </FormGroup>
    </Box>
  );
};

export default QuestionBillableSwitch;

